/**
 * Loads the Curricular Competency goals XLSX from src/utils/learningSupportData
 * and returns its content as plain text (all sheets) for the AI prompt.
 */

import * as XLSX from "xlsx";

// File is in this folder; bundler gives URL
import curricularGoalsXlsxUrl from "./curricular_goals.xlsx";

let cachedText = null;

/**
 * Convert a worksheet to plain text (tab-separated rows).
 * @param {object} workbook - XLSX workbook
 * @returns {string}
 */
function workbookToText(workbook) {
  const parts = [];
  const sheetNames = workbook.SheetNames || [];

  for (const name of sheetNames) {
    const sheet = workbook.Sheets[name];
    if (!sheet) continue;

    try {
      const rows = XLSX.utils.sheet_to_json(sheet, {
        header: 1,
        defval: "",
        raw: false
      });

      const lines = rows
        .map((row) => (Array.isArray(row) ? row.map((c) => String(c ?? "").trim()).join("\t") : String(row)))
        .filter((line) => line.replace(/\t/g, "").trim() !== "");

      if (lines.length > 0) {
        parts.push(`--- ${name} ---\n${lines.join("\n")}`);
      }
    } catch (e) {
      console.warn("curricularGoalsFromXlsx: skip sheet", name, e);
    }
  }

  return parts.join("\n\n");
}

/**
 * Fetch XLSX from public URL, parse it, return full goal bank as text.
 * Cached after first successful load.
 * @returns {Promise<string>} Full curricular goals text or "" on failure.
 */
export async function getCurricularGoalsBankFromXlsx() {
  if (cachedText !== null) return cachedText;

  try {
    const url = curricularGoalsXlsxUrl.startsWith("http") ? curricularGoalsXlsxUrl : (window.location.origin + (curricularGoalsXlsxUrl.startsWith("/") ? "" : "/") + curricularGoalsXlsxUrl);
    const res = await fetch(url, { cache: "default" });
    if (!res.ok) {
      console.warn("curricularGoalsFromXlsx: fetch failed", res.status, url);
      return "";
    }
    const ab = await res.arrayBuffer();
    const workbook = XLSX.read(ab, { type: "array", cellText: true });
    const text = workbookToText(workbook);
    cachedText = text || "";
    // Console: Excel data load hua — yahan se pass hota hai
    console.log("[Excel Goal Bank] Loaded from XLSX. Length:", cachedText.length, "chars. Sheets:", workbook.SheetNames);
    console.log("[Excel Goal Bank] Preview (first 800 chars):", cachedText.slice(0, 800));
    return cachedText;
  } catch (err) {
    console.warn("curricularGoalsFromXlsx: load/parse error", err);
    return "";
  }
}
